import ecoAllianceMemberBenefit from './contentfulExports/ecoAllianceMemberBenefit.json';

const useEcoAllianceMemberBenefit = () => {
  return ecoAllianceMemberBenefit;
}

export default useEcoAllianceMemberBenefit;
